import type { FC, ReactNode } from 'react'

import { processSteps } from '@/constants/content'

type ProcessProps = {
    variant?: 'home' | 'details'
}

export const Process: FC<ProcessProps> = ({ variant = 'home' }): ReactNode => {
    const isHome = variant === 'home'

    return (
        <section
            id='process'
            className={isHome ? 'how-it-works-section section-padding' : 'how-it-works-section _02 section-padding'}
        >
            <div className='w-layout-blockcontainer container w-container'>
                <div className='section-content-wrapper'>
                    <div className='section-title-wrapper align-center' data-reveal>
                        <h2 className={isHome ? 'section-title style-02' : 'section-title'}>
                            How your project works
                        </h2>

                        <p className={isHome ? 'section-subtitle style-02 process' : 'section-subtitle process'}>
                            Our commitment to excellence means every project is handled properly,
                            and your home or business is treated with the care it deserves.
                        </p>
                    </div>

                    <div className='process-wrapper' data-reveal-stagger='0.12'>
                        {processSteps.map((step, index) => (
                            <div
                                key={step.number}
                                className={`single-process ${index % 2 === 0 ? 'style-02' : 'style-01'}`}
                            >
                                <p className='process-number'>
                                    {step.number}
                                </p>

                                <div className='process-title-wrapper'>
                                    <p className='process-title'>
                                        {step.title}
                                    </p>

                                    <p className='process-subtitle'>
                                        {step.subtitle}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
